import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import type { Slide } from './slides';
type Props = {
  slides: Slide[];
  index: number;
  onPrev: () => void;
  onNext: () => void;
  onGoTo: (i: number) => void;
};
export function DeckNav({
  slides,
  index,
  onPrev,
  onNext,
  onGoTo
}: Props) {
  const total = slides.length;
  return <div className="pointer-events-none fixed inset-x-0 bottom-0 z-20 flex items-center justify-between gap-4 border-t border-white/[0.06] bg-bg/80 px-5 py-4 backdrop-blur-md sm:px-8" data-id="element-14" data-mp="9z9g7npzzdc4">
      {/* Counter */}
      <div className="pointer-events-auto flex items-center gap-2 font-mono text-sm text-slate-500" data-id="element-15" data-mp="3dhavuj1phscu">
        <span className="text-white" data-id="element-16" data-mp="3rcv3gibzio4y">{String(index + 1).padStart(2, '0')}</span>
        <span className="text-slate-600" data-id="element-17" data-mp="3nbt31y6c061e">/</span>
        <span data-id="element-18" data-mp="16ogss68n2c3w">{String(total).padStart(2, '0')}</span>
      </div>

      {/* Dots */}
      <nav aria-label="Slides" className="pointer-events-auto hidden items-center gap-2 md:flex" data-id="element-19" data-mp="12n5bqp3tyz7b">
        {slides.map((s, i) => <button key={s.id} onClick={() => onGoTo(i)} aria-label={`Go to slide ${i + 1}: ${s.section}`} aria-current={i === index} className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? 'w-8 bg-accent' : 'w-1.5 bg-slate-600 hover:bg-slate-400'}`} data-id="element-20" data-mp="zgo3enff8de9" data-mpi={i} />)}
      </nav>

      {/* Prev / Next */}
      <div className="pointer-events-auto flex items-center gap-2" data-id="element-21" data-mp="grzii1gxu82h">
        <button onClick={onPrev} disabled={index === 0} aria-label="Previous slide" className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/[0.08] bg-panel text-slate-300 transition-colors hover:border-white/20 hover:text-white disabled:cursor-not-allowed disabled:opacity-30" data-id="element-22" data-mp="ks9y85uj8cuj">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-23" data-mp="3t835rv6vydzg" />
        </button>
        <button onClick={onNext} disabled={index === total - 1} aria-label="Next slide" className="flex h-10 items-center justify-center gap-1.5 rounded-lg border border-accent/30 bg-accent/10 px-4 text-sm font-semibold text-accent transition-colors hover:bg-accent/20 disabled:cursor-not-allowed disabled:opacity-30" data-id="element-24" data-mp="210d0zbefzn4">
          Next
          <ChevronRightIcon className="h-4 w-4" data-id="element-25" data-mp="1a36206pks91u" />
        </button>
      </div>
    </div>;
}